export const messages = {
  'error.403': "You don't have access to this resource, or it has been removed",
  'error.404': "Sorry, we can't find what you're looking for",
  'error.500': 'Something went wrong on our side',
  'validation.genericRequired': "This field is required",
};